var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.87109 5.75391C2.51562 5.42578 2.51562 4.85156 2.87109 4.52344L6.37109 1.02344C6.53516 0.859375 6.75391 0.75 7 0.75C7.21875 0.75 7.4375 0.859375 7.60156 1.02344L11.1016 4.52344C11.457 4.85156 11.457 5.42578 11.1016 5.75391C10.7734 6.10938 10.1992 6.10938 9.87109 5.75391L7.875 3.75781V10.375C7.875 10.8672 7.46484 11.25 7 11.25C6.50781 11.25 6.125 10.8672 6.125 10.375V3.75781L4.10156 5.75391C3.77344 6.10938 3.19922 6.10938 2.87109 5.75391ZM13.125 10.375C13.5898 10.375 14 10.7852 14 11.25V13.875C14 14.3672 13.5898 14.75 13.125 14.75H0.875C0.382812 14.75 0 14.3672 0 13.875V11.25C0 10.7852 0.382812 10.375 0.875 10.375H5.25C5.25 11.3594 6.01562 12.125 7 12.125C7.95703 12.125 8.75 11.3594 8.75 10.375H13.125ZM11.8125 13.2188C12.168 13.2188 12.4688 12.9453 12.4688 12.5625C12.4688 12.207 12.168 11.9062 11.8125 11.9062C11.4297 11.9062 11.1562 12.207 11.1562 12.5625C11.1562 12.9453 11.4297 13.2188 11.8125 13.2188Z",
    fill: "#1D252D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsUpload);
export default __webpack_public_path__ + "static/media/icons_upload.834edecf.svg";
export { ForwardRef as ReactComponent };